import React from 'react';
import '../../../styles/modal.css';

const Modal = ({ text, onClickAccept, onClickReject, loading }) => {
  return(
    <div className="modalOuter">
      {
        loading ?
          <div className="modalContainer">
            <div className="modalLoadingText">Loading...</div>
          </div> :
          <div className="modalContainer">
            <div className="modalTitle">{text}</div>
            <div className="modalButtons">
              <div className="button buttonReject" onClick={onClickReject}>No</div>
              <div className="button buttonAcccept" onClick={onClickAccept}>Yes</div>
            </div>
          </div>
      }
    </div>
  );
};

export { Modal };



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/components/Modal.js